import { Entity } from 'src/app/core/data/schema/entity';

export class Profile extends Entity {

    static className = 'Profile';
    static idField = 'userId';

    static class = 'Profile';

    emailConfirmed: boolean = false;
    firstName: string = '';
    lastName: string = '';
    loginMethod: number = 0;
    registrationDate: string = '';
    roles: string[] = [];
    status: number = 0;
    userId: number = 0;
    username: string = '';

    // payment settings
    stripeSecretKey: string;
    payPalClientId: string;
    payPalSecretKey: string;
    squareAccessToken: string;
    squareLocationId: string;

    public constructor(profile?: Partial<Profile>) {
        super('User', 'userId', 'users');
        Object.assign(this, profile);
    }

    public static async loadMine() {
        return await Profile.getObject(Profile, 'users');
    }

    get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }
}
